import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./component/booking-container/booking-container.component').then(m => m.BookingContainerComponent),
    },
    {
        path: 'list',
        loadComponent: () => import('./component/booking-list/booking-list.component').then(m => m.BookingListComponent),
    },
    {
        path: 'details/:bId',
        loadComponent: () => import('./component/booking-details/booking-details.component').then(m => m.BookingDetailsComponent),
    },
    {
        path: 'details/pid/:pId',
        loadComponent: () => import('./component/booking-details/booking-details.component').then(m => m.BookingDetailsComponent),
    },
    {
        path: 'confirmation',
        loadComponent: () => import('./component/booking-confirmation/booking-confirmation.component').then(m => m.BookingConfirmationComponent),
    },
];
